// extracted by mini-css-extract-plugin
export default {"clock":"GameClock_clock__LyVuD","label":"GameClock_label__75eBH","value":"GameClock_value__pJzJd","dot":"GameClock_dot__86eQ7","elapsed":"GameClock_elapsed__+rUP6"};